import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import actions from '@src/redux/actions';
import ReferralErrorIcon from '@src/assets/images/referral-error-noti.svg';
import DialogWithContent from '@src/components/DialogWithContent';
import { removeQueryParams } from '@src/utils/url';
import {
  AUTO_APPLY_REFERRAL_PARAM,
  REFERRAL_CODE_PARAM,
} from '@src/constants/referral';
import {
  StyledReferralErrorDialogAction,
  StyledReferralErrorDialogContent,
} from './index.style';

const ReferralErrorDialog = ({ referralCode }) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isOpeningReferralErrorNotiPopup } = useSelector(
    (state) => state.user,
  );

  const handleClose = () => {
    dispatch(actions.user.closeReferralErrorNotiPopup());
    if (referralCode) {
      history.replace({
        pathname: location.pathname,
        search: removeQueryParams(location.search, [
          REFERRAL_CODE_PARAM,
          AUTO_APPLY_REFERRAL_PARAM,
        ]),
      });
    }
  };

  const renderAction = () => (
    <StyledReferralErrorDialogAction>
      <Button
        variant="contained"
        className="dialog-actions-button"
        onClick={handleClose}
      >
        {t('gotIt')}
      </Button>
    </StyledReferralErrorDialogAction>
  );

  const renderContent = () => (
    <StyledReferralErrorDialogContent>
      <Typography className="description">
        {t('cannotUseReferralCodeDescription')}
      </Typography>
    </StyledReferralErrorDialogContent>
  );

  return (
    <DialogWithContent
      open={isOpeningReferralErrorNotiPopup}
      onClose={handleClose}
      title={t('cannotUseReferralCode')}
      image={ReferralErrorIcon}
      contentPopup={renderContent()}
      actionComponent={renderAction()}
    />
  );
};

export default ReferralErrorDialog;
